import React from 'react';
import './App.css';
import { BrowserRouter,Switch,Route, Redirect } from "react-router-dom"
import Login from './component/login/login';
import Register from './component/register/register';
import Home from './component/Dashboard/home/home.js';
import Cart from './component/Dashboard/cart/cart';
import Singledish from './component/Dashboard/home/categories/singledish';
import Alldish from './component/Dashboard/All dish/alldish';
import ProfileNew from './component/Dashboard/profile/profile-new';
import { Provider } from 'react-redux';
import store from './redux/store';
import { getTotals } from './component/Dashboard/cart/cartslice';
import AboutUs from './component/Dashboard/AboutUs';
import Team from './component/Dashboard/Team';
import ContactUs from './component/Dashboard/ContactUs';
import Favorites from './component/Dashboard/Favorites';
import Admin from './component/Dashboard/Admin';
import MyOrders from './component/Dashboard/orders/myorders';
import Checkout from './component/Dashboard/orders/checkout';
import TopRated from './component/Dashboard/reviews/TopRated';
import SearchResults from './component/Dashboard/search/SearchResults';
import OrderTracking from './component/Dashboard/orders/OrderTracking';
import AdminOrders from './component/Dashboard/orders/AdminOrders';

const ProtectedRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={(props) => {
      const token = localStorage.getItem('token');
      if (!token) {
        return <Redirect to="/login" />;
      }
      return <Component {...props} />;
    }}
  />
);

function App() {
  store.dispatch(getTotals())

  return (
    <div style={{height:'100%'}}>
      
      <BrowserRouter>
      <Provider store={store}>
      <Switch>
  <Route exact path='/'> <Home /> </Route>
  <Route path='/login'> <Login /> </Route>
  <Route path='/register'> <Register /> </Route>
          <Route path='/home'> <Home /></Route>
          <Route path='/search'> <SearchResults /></Route>
          <ProtectedRoute path='/cart' component={Cart} />
          <ProtectedRoute path='/checkout' component={Checkout} />
          <ProtectedRoute path='/orders/:orderId/track' component={OrderTracking} />
          <Route path='/singledish'> <Singledish /></Route>
          <Route path='/alldish'> <Alldish /></Route>
          <ProtectedRoute path='/profile' component={ProfileNew} />
  <Route path='/about'> <AboutUs /> </Route>
  <Route path='/team'> <Team /> </Route>
  <Route path='/contact'> <ContactUs /> </Route>
  <ProtectedRoute path='/favorites' component={Favorites} />
  <ProtectedRoute path='/admin/orders' component={AdminOrders} />
  <ProtectedRoute path='/admin' component={Admin} />
  <ProtectedRoute path='/myorders' component={MyOrders} />
  <Route path='/toprated'> <TopRated /> </Route>
      </Switch>
      </Provider>
      </BrowserRouter>
    </div>
  );
}

export default App;
